import React from "react";
import { useQuery } from "@apollo/client";
import Header from "../../../components/common/header";
import { FaHeart } from "react-icons/fa";
import { GET_SELLER_STORE } from "../api/seller-store";
import { useNavigate } from "react-router-dom";
import { GET_STORE_LIKES } from "../page";
import LoadingSpinnerFull from "../../../components/common/loading-spinner/loading-spinner-full";

const BossLikes: React.FC = () => {
  const navigate = useNavigate();
  const { data, loading, error } = useQuery(GET_STORE_LIKES);
  const {
    data: storeData,
    loading: storeLoading,
    error: storeError,
  } = useQuery(GET_SELLER_STORE, {
    fetchPolicy: "network-only",
  });

  if (loading || storeLoading) return <LoadingSpinnerFull />;
  if (error || storeError)
    return <p>오류: {error?.message || storeError?.message}</p>;

  if (!storeData?.getSellerStore) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
        <p className="text-lg mb-6 text-gray-700">
          매장이 아직 등록되지 않았습니다.
        </p>
        <button
          onClick={() => navigate("/boss/my/store-management")}
          className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 transition duration-300"
        >
          매장 추가하러 가기
        </button>
      </div>
    );
  }

  const likes = data?.getStoreLikes || [];

  return (
    <>
      <Header title="매장 좋아요" showBackButton />
      <div className="flex flex-col gap-6 w-full max-w-4xl bg-[#f4f5f7] p-6 rounded-lg shadow-lg min-h-screen">
        {/* Total Likes Summary */}
        <div className="flex flex-col gap-3">
          {/* 좋아요 설명 추가 */}
          <div className="bg-blue-50 p-4 rounded-lg shadow-sm">
            <p className="text-blue-600 text-lg">
              💡 좋아요를 누른 고객에게는 매장의 새로운 할인 소식이 알림으로
              전달됩니다
            </p>
          </div>
          <div className="flex items-center bg-white p-4 rounded-lg shadow-md">
            <FaHeart className="text-red-500 w-10 h-10" />
            <span className="ml-4 text-lg font-semibold text-gray-800">
              현재 <strong className="text-red-500">{likes.length}</strong>명이
              매장을 좋아요하고 있어요!
            </span>
          </div>
        </div>

        {/* Likes List */}
        <div className="bg-white p-4 rounded-lg shadow-md">
          <h4 className="text-lg font-semibold mb-4">좋아요 누른 고객 목록</h4>
          <div className="space-y-3">
            {likes.map((like: any) => {
              // 이름 유효성 검사 함수 추가
              const isValidName = (name: string | undefined | null) => {
                if (!name) return false;
                if (name.includes("undefined")) return false;
                if (name.trim() === "") return false;
                return true;
              };

              const displayName = isValidName(like.user?.name)
                ? like.user?.name
                : "이름 없음"; // 게스트도 이름 없음으로 표시

              return (
                <div
                  key={like.id}
                  className="flex items-center justify-between border-b border-gray-100 py-2 last:border-0"
                >
                  <div className="flex items-center max-w-[60%]">
                    <FaHeart className="text-red-500 w-4 h-4 mr-3 flex-shrink-0" />
                    <span
                      className={`font-medium truncate ${
                        !isValidName(like.user?.name) && "text-gray-400"
                      }`}
                      title={displayName}
                    >
                      {displayName}
                    </span>
                  </div>
                  <span className="text-sm text-gray-500">
                    {new Date(like.createdAt).toLocaleDateString()}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default BossLikes;
